import { render, staticRenderFns } from "./HistoricoInformeData.vue?vue&type=template&id=2f75badd&scoped=true&"
import script from "./HistoricoInformeData.vue?vue&type=script&lang=ts&"
export * from "./HistoricoInformeData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f75badd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2f75badd', component.options)
    } else {
      api.reload('2f75badd', component.options)
    }
    module.hot.accept("./HistoricoInformeData.vue?vue&type=template&id=2f75badd&scoped=true&", function () {
      api.rerender('2f75badd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/HistoricoInforme/HistoricoInformeData.vue"
export default component.exports